import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import { AuthContext } from "../../store/auth-context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { URL } from "../../constants";
import styles from "../../styles/MainNavigation.module.css";

const CommonNavigation = () => {
  const authCtx = useContext(AuthContext);

  return (
    <div className="dropdown">
      <button
        className={`dropdown-toggle border-0 ${styles.profileDropdown} d-flex align-items-center`}
        id={styles.dropdownMenuButton}
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <span className={`rounded-circle ${styles.profileIcon}`}>
          {authCtx.profilePic && authCtx.profilePic != "null" ? (
            <img
              src={authCtx.profilePic}
              className="rounded-circle w-100"
              alt="..."
            />
          ) : (
            <FontAwesomeIcon icon={faUser} />
          )}
        </span>
      </button>
      <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
        {/* <NavLink className="dropdown-item" to='/'>Manager View</NavLink>
                <NavLink className="dropdown-item" to={URL.agent}>Agent view</NavLink> */}
        <NavLink className="dropdown-item" to={URL.logout}>
          Logout
        </NavLink>
      </div>
    </div>
  );
};

export default CommonNavigation;
